import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Global as EmotionGlobal } from '@emotion/react';

// 1) Import Mantine's core CSS
import '@mantine/core/styles.css';

import App from './App';
import 'react-phone-number-input/style.css'

// 2) Define your custom GlobalStyles with EmotionGlobal
function GlobalStyles() {
  return (
    <EmotionGlobal
      styles={{
        '*, *::before, *::after': {
          boxSizing: 'border-box',
        },
        body: {
          margin: 0,
          padding: 0,
          // Apple-like font stack
          fontFamily:
            '"SF Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          backgroundColor: '#ffffff',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      }}
    />
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 3) Wrap your entire app in BrowserRouter + MantineProvider */}
    <BrowserRouter>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        {/* 4) Inject custom global styles for your SF Pro stack */}
        <GlobalStyles />

        <App />
      </MantineProvider>
    </BrowserRouter>
  </React.StrictMode>
);
